import React from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import queryString from 'query-string';
import CircularProgressbar from "../common/CircularProgressbar";
import { Nav, NavItem, NavLink } from 'reactstrap';
import { ScrollspyNavLink } from 'reactstrap-scrollspy';
import { Scrollspy } from 'reactstrap-scrollspy'
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import SectionLoadingError from "../common/SectionLoadingError";
import Spinner from '../common/spinner';
import Accordion from './Accordion';

class WellBeingReport extends React.Component {
    constructor(props) {
        super(props);
        const { wellnessDueDate } = this.props.serverData;
        this.onPageLoad = this.onPageLoad.bind(this);
        this.loadReport = this.loadReport.bind(this);
        this.printReport = this.printReport.bind(this);
        this.state = {
            stickyNavClass: "",
            hideNavLink: false,
        };

        this.currentYear = new Date(wellnessDueDate).getFullYear();
        this.throttle = _.throttle(this.handleStickyNav.bind(this), 150, { maxWait: 100 });
    }

    componentDidMount() {
        const { userToken } = this.props;
        this.props.getWellBeingReport(userToken, this.currentYear);
        logUI("MBHWeb.UI.WellBeingReport.ComponentDidMount", new Date(), Tools.getURLPath());
        if (typeof window !== 'undefined') {
            window.addEventListener('load', this.onPageLoad);
            window.addEventListener('scroll', this.throttle);
            this.handleStickyNav();
        }
        this.onPageLoad();

        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (location.pathname === this.props.history.location.pathname) {
                setTimeout(() => this.scrollIntoView(), 100);
            }
        });

    }
    printReport() {
        const { userToken } = this.props;
        this.props.getReportPdf(userToken, this.currentYear);
        logUI("MBHWeb.UI.WellBeingDashboard.WellBeingReport.GetReportPdf.Clicked", new Date(), Tools.getURLPath());
    }

    onPageLoad() {
        // wait until the page is rendered and scroll into view
        setTimeout(() => this.scrollIntoView(), 1000);
    }

    isMobile() {
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        return windowWidth && (windowWidth < 768);
    }

    getHash() {
        const { location } = this.props;
        return location && location.hash ? decodeURI(location.hash.substr(1).trim()) : ""
    }

    loadReport(report, faqHash) {
        var faqId = "";
        if (faqHash) {
            const faqIdEnd = faqHash.indexOf("-q");
            if (faqIdEnd !== -1) {
                faqId = faqHash.substr(0, faqIdEnd);
            } else {
                faqId = faqHash;
            }
        }
        const reportContent = report.wellnessQuestionsGroups.map((group, index) => {
            return <div key={index} id={(this.isMobile() ? "" : group.groupTitle.trimEnd().replace(' ', '_'))} className={"answer-group" + (group.groupTitle.trimEnd().replace(' ', '_') === faqId ? " faq-active " : "") + (group.groupTitle === 'Overall' ? ' hidden' : '')}  >
                <div className="category-heading">
                    <div className="visible-mobile">
                        <CircularProgressbar percentage={group.groupScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                        </div>
                    <div className="page-heading">{group.groupTitle}<span className="hide-mobile">:</span></div>
                    <div className="hide-mobile">
                        <CircularProgressbar percentage={group.groupScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                        </div>
                </div>

                <div className="category-body">
                    <div className="row">
                        <div className="col-11 col-lg-12">
                            <div>
                                {group.wellnessQuestions.map(question => {
                                    return <div key={question.questionId} className="each-question">
                                        <h3 id={question.questionId} ><strong dangerouslySetInnerHTML={{
                                            __html: question.questionTitle
                                        }} ></strong></h3>
                                        <ul>
                                            {question.answers.map(answer => {
                                                return <li key={answer.optionId} dangerouslySetInnerHTML={{
                                                    __html: answer.optionText
                                                }}></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        })
        const overAllSection = <div id={(this.isMobile() ? "" : "overAllScore")} className={"answer-group " + (faqId === 'overAllScore' ? " faq-active" : "")}>
            <div className="category-heading">
                <div className="visible-mobile">
                    <CircularProgressbar percentage={report.overallScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                </div>
                <div className="page-heading">{report.overallScoreTitle}<span className="hide-mobile">:</span></div>
                <div className="hide-mobile">
                    <CircularProgressbar percentage={report.overallScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                </div>
                
            </div>

            <div className="category-body">
                <div className="row">
                    <div className="col-12">
                        <div>
                            <p>{report.overallScoreInterpretation}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        reportContent.unshift(overAllSection);

        const stickyMenu = <div id="wellbeing-menu" className={"wellbeing-menu sticky-nav" + this.state.stickyNavClass + (faqHash ? " hide-menu" : "")}>
            <Nav vertical className="sidebar-container">
                <NavItem key={0} onClick={(e) => this.onMenuClick(e)}>
                    <ScrollspyNavLink name="overAllScore">
                        
                        <NavLink href="#overAllScore" className="link-category">
                            <div className="mobile-score"><CircularProgressbar percentage={report.overallScore} overallScoreColor={"#008fbe"} rotation={0.00} /></div> Overall Score</NavLink>

                    </ScrollspyNavLink>
                </NavItem>
                {report.wellnessQuestionsGroups.map((group, index) => {
                    return (group.groupTitle === 'Overall' ? '' : <NavItem key={index + 1} onClick={(e) => this.onMenuClick(e)}>
                        <ScrollspyNavLink name={group.groupTitle}>
                           
                            <NavLink href={`#${group.groupTitle.trimEnd().replace(' ', '_')}`} className={`link-category ${(group.groupTitle === 'Overall') ? ' hidden' : ''}`} >
                                <div className={`mobile-score ${(group.groupTitle === 'Overall') ? ' hidden' : ''}`}><CircularProgressbar percentage={group.groupScore} overallScoreColor={"#008fbe"} rotation={0.00} /></div> {group.groupTitle}</NavLink>
                        </ScrollspyNavLink>
                    </NavItem>)
                })
                }
            </Nav>
        </div>

        reportContent.unshift(stickyMenu);

        return reportContent;
    }
    onMenuClick(event) {
        if (this.isMobile()) {
            window.scrollTo({ top: 0 });
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('load', this.onPageLoad);
            window.removeEventListener('scroll', this.throttle);
        }
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    getTop(el) {
        return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
    }


    scrollIntoView() {
        // everytime a menu link is clicked, this is called 100 ms later
        const reportHash = this.getHash();

        if (reportHash) {
            const element = document.getElementById(reportHash);
            const minimizedHeader = document.getElementsByClassName('page-scrolled-down')

            if (element) {
                let pos = this.getTop(element);
                if (minimizedHeader.length === 0) {
                    // account for header maximizing in size when user is scrolling/scrolled up
                    window.scrollTo({
                        top: pos - 31,
                        behavior: 'smooth'
                    })
                }
                else {
                    element.scrollIntoView();
                }
            }
            else {
                window.scrollTo({ top: 0 });
            }
        }
    }

    handleStickyNav(event) {
        if (typeof window !== 'undefined') {
            const scrollY = window.pageYOffset;
            const topOffsetHeight = 90;
            if (scrollY > topOffsetHeight) {
                if ((this.state.scrollTopY + topOffsetHeight) < scrollY) {
                    this.setState({
                        scrollTopY: scrollY,
                        stickyNavClass: " sticky-nav-fixed"
                    });
                }
                else if ((this.state.scrollTop - topOffsetHeight) > scrollY) {
                    this.setState({
                        scrollTopY: scrollY,
                        stickyNavClass: ""
                    });
                }
            }
            else {
                this.setState({
                    scrollTopY: scrollY,
                    stickyNavClass: ""
                });
            }
        }
    }

    toggleAccordion = (val) => {
        if (val) {
            this.setState({
                hideNavLink: true,
            })
        } else {
            this.setState({
                hideNavLink: false,
            })
        }


    }



    render() {
        const { report, isReportFailure, isReportPending, isReportSuccess, isProxyUser } = this.props;
        let scrollSpyNames = ['overAllScore'];
        const reportHash = this.getHash();

        const reportContent = report ? this.loadReport(report, reportHash) : "";
        if (report != null) {
            report.wellnessQuestionsGroups.map(group => {
                scrollSpyNames.push(group.groupTitle);
            })
            scrollSpyNames.unshift("wellbeing-menu");
        }
        return (
            < React.Fragment >
                <div className="container-fluid body-content wellbeing-container">
                    {isReportPending ? <Spinner /> :
                        <>
                            {isProxyUser ?
                                <SectionLoadingError message="We’re sorry, but this page is not available to you." sectionErrorClass="not-available-error" titleIcon="icon-log-out" />
                                :
                                isReportFailure ?
                                    <SectionLoadingError message="Sorry, we are not able to display your report. Please try again later." />
                                    :
                                    <>
                                        {(isReportSuccess && report) &&
                                            <div className="row">
                                                <div className="col-12 maxWidth-content">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="page-heading wellbeing-heading">{this.currentYear} Well-being Report
                                                            {reportHash !== "" ?
                                                                <div className="show-all-link">
                                                                    <Link to="/wellbeingreport" onClick={(e) => this.onMenuClick(e)}>SEE ALL</Link>
                                                                </div> : <span className="icon-print" onClick={this.printReport}></span>
                                                            }
                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row scrollspy-container">
                                                        <div>
                                                            <Scrollspy
                                                                names={scrollSpyNames}
                                                                children={reportContent}
                                                                homeIndex={1}
                                                                topOffset="30%"
                                                                bottomOffset="80%"
                                                            >
                                                            </Scrollspy>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        }

                                    </>
                            }
                        </>
                    }
                </div>
            </React.Fragment >
        )
    }
}



const mapStateToProps = (state) => {
    return {
        report: state.thrive.wellBeingReport,
        isReportPending: state.thrive.wellBeingReportPending,
        isReportSuccess: state.thrive.wellBeingReportSuccess,
        isReportFailure: state.thrive.wellBeingReportFailure,
        userToken: state.domain.t,
        serverData: state.session.serverData,
        isProxyUser: state.domain.ip
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWellBeingReport: (token, reportYear) => {
            dispatch({ type: types.GET_WELLBEING_REPORT, token, reportYear });
        },
        getReportPdf: (token, reportYear) => { dispatch({ type: types.GET_WELLNESS_REPORT_PDF, token, reportYear }) }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WellBeingReport));